import React from "react";
import "./ContactUs.css";
import {submitFeedback}  from "../../utilities/js/callouts/CalloutFactory";
import InputBox from "../../components/reusable/InputBox";
import BracksetHeader from "components/reusable/BracksetHeader";
import BracksetFooter from "components/reusable/BracksetFooter";
import Constants from "utilities/js/Constants";

const loadingIcon = Constants.ICON_LOADING;

class ContactUs extends React.Component {
    
    constructor(props){
        super(props);
        this.state = {
            email: '',
            email: '',
            feedback: '',
            isLoading: false,
            isError: false,
            errorMessage: "There was a problem sending your feedback",
            inputError: null,
            submitSuccess: false
        };
        
        this.displayContent = this.displayContent.bind(this);
        this.submitFeedback = this.submitFeedback.bind(this);
        this.setEmail = this.setEmail.bind(this);
        this.setComments = this.setComments.bind(this);
        
    }
    
    componentDidMount(){
        
    }
    
    
    
    setEmail(event){
        this.setState({email: event.target.value});
    }
    setComments(event){
        this.setState({comments: event.target.value});
    }

    get errorStringClass(){
        if(this.state.inputError){
            return 'error-messages'
        }else{
            return 'hidden';
        }
    }
    
    submitFeedback(){
        if(this.areInputsValid()){
            
            this.setState({isLoading: true});
            submitFeedback({email: this.state.email, comments: this.state.comments}).then(response => {
                this.setState({isError: false, submitSuccess: true});
            }).catch(error => {
                if(error.code){
                    this.setState({errorMessage: error.message, isError: true})
                }else{
                    this.setState({isError: true});
                }
            }).finally(() => {
                this.setState({isLoading: false});
            });
        }
    }
    


    areInputsValid(){
        let errorDisplay;
        if(!this.state.email || !this.state.comments){
            errorDisplay = 'You must populate all fields';
        }else if(this.state.comments.length < 50 || this.state.comments.length > 1000){
            errorDisplay = 'All feedback must be a minimum of 50 characters and maximum of 1000';
        }
        if(errorDisplay){
            this.setState({inputError: errorDisplay});
            // this.registerInputContainerRef.current.scrollTop = 0;
            return false;
        }

        return true;
    }
    
    displayContent(){
        if(this.state.submitSuccess){
            return (
                <>
                    <div className="simple-form-result-container">
                        <div className="simple-form-header">Thank you!</div>
                        <div className="simple-form-success-result">Your questions and feedback are greatly appreciated!  Click <a href="/">here</a> to navigate to the home page</div>
                    </div>
                </>
            )
        }else if(this.state.isError){
            return (<>
                <div className="simple-form-result-container">
                    <div className="simple-form-header">Something went wrong...</div>
                    <div className="simple-form-error-result">
                        {this.state.errorMessage}
                        <div className="simple-form-redirect">Click <a href="/">here</a> to navigate to the home page</div>
                    </div>
                </div>
            </>)
        }else{
            return (
            <>
                <div className="">
                    
                    <div className="login-form-header-container">
                        <div className="login-form-header">Contact Us</div>
                        <div className="login-form-sub-header">We're always trying to improve Brackset so any input, feedback, advice, or question is encouraged.  Let us know what we could be doing better!</div>

                        <div className={this.errorStringClass}>
                            {this.state.inputError}
                        </div>
                    </div>
                    <div className="input-container">
                        <div className="simple-form-input-label">Email</div>
                        <InputBox uniqueKey="email" name='email' placeholder='email' class='login-styled-input' value={this.state.email} valueChangedCallback={this.setEmail}></InputBox>
                    </div>
                    <div className="input-container">
                        <div className="simple-form-input-label">Comments</div>
                        <InputBox uniqueKey="comments" name='comments' type="textarea" placeholder='Comments, Questions, and Feedback' class='login-styled-input' rows='8' value={this.state.comments} valueChangedCallback={this.setComments}></InputBox>
                    </div>
                    <div className="login-button-container">
                        <button label='submit-button' className='nav-button' onClick={this.submitFeedback}>Submit</button>
                    </div>
                </div>
            </>
            )
        }
    }
            
    render(){
        let content = (<div className="loading-icon-container"><img src={loadingIcon} alt="loading"></img></div>)
        if(!this.state.isLoading){
            content = (<>{this.displayContent()}</>);
        }
        
        return (
            <>
            <div className="brackset-container">
                
                <BracksetHeader hideSearch="true" navigateHomeOnLogin="true"></BracksetHeader>
                <div className="simple-form">
                    {content}
                </div>
                <BracksetFooter></BracksetFooter>

            </div>
            </>
        )
            
    }
}

export default ContactUs;
    